export const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
});
